module.exports = __webpack_public_path__ + "img/Icon-material-delete.31d6a9a5.svg";